import axios from 'axios';
import Vue from 'vue'

export default {

    getAllBySupplier (page, pageSize, showDrafts,status,customerId,isSupplier) {
        return axios.get('/api/local-invoice/list', { params: { page: page, pageSize: pageSize, showDrafts: showDrafts , status:status,customerId:customerId,isSupplier:isSupplier} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    get (localInvoiceId) {
        return axios.get('/api/local-invoice/get', { params: { localInvoiceId: localInvoiceId } })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findAllCustomersAndSuppliers () {
        return axios.get('/api/local-invoice/get-all-customers')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    shareWithCustomer (localInvoiceId) {
        return axios.get('/api/local-invoice/share-with-customer', { params: { localInvoiceId: localInvoiceId } })
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Facture partagée avec le client");
                return response.data
            } 
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getWithHolding(localInvoiceId,localInvoiceRef ){
        const localInvoiceRefStr = parseInt(localInvoiceRef, 10).toString().padStart(3, '0');
        axios({
            url:'/api/local-invoice/download-local-invoice/'+localInvoiceId,
            method: 'GET',
            responseType: 'blob',
          }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
           link.href = url;
            link.setAttribute('download', localInvoiceRef==undefined ?'Facture.pdf':'Facture-'+localInvoiceRefStr+'.pdf');
            document.body.appendChild(link);
            link.click();
          }).catch(() => {
              Vue.prototype.$snotify.error("La géneration du pdf a échoué");});
    },

    editLocalInvoice (localInvoice) {
        return axios.post('/api/local-invoice/add',localInvoice)
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    addLineToInvoice (addLineToInvoice) {
        return axios.post('/api/local-invoice/add/line', addLineToInvoice)
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    removeLocalInvoiceLine (localInvoiceLine) {  
        return axios.post('/api/local-invoice/remove/line',localInvoiceLine )
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    //valider local invoice 

    submitLocalInvoice(localInvoice) {    
        return axios.post('/api/local-invoice/submit', localInvoice)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("La facture a été validée avec succès.");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error); return false;})
    },

    cancelLocalInvoice(localInvoice) {    
        return axios.post('/api/local-invoice/cancel', localInvoice)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("La facture a été annulée avec succès.");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error); return false;})
    },

    mergeLocalInvoice(localInvoice) {    
        return axios.post('/api/local-invoice/merge', localInvoice)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Les deux factures ont été fusionnées avec succès.");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error); return false;})
    },

    setPaymentLocalInvoice (localInvoice) {
        return axios.post('/api/local-invoice/set/payment',localInvoice)
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    removeLocalInvoice(localInvoiceLine) {
        return axios.post('/api/local-invoice/remove',localInvoiceLine )
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    exportEXCEL(startDate , endDate){
        const url = `/api/local-invoice/export/excel/?startDate=${startDate}&endDate=${endDate}`;
        axios({
            url:url,
            method: 'GET',
            responseType: 'blob', // important
          }).then((response) => {

                const blob = new Blob(
                    [response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' })
                    const aEle = document.createElement('a');     // Create a label
                    const href = window.URL.createObjectURL(blob);       // Create downloaded link
                    aEle.href = href;
                    aEle.download = response.headers["filename"];  // File name after download
                    document.body.appendChild(aEle);
                    aEle.click();     // Click to download
                    document.body.removeChild(aEle); // Download complete remove element
                    window.URL.revokeObjectURL(href) // Release blob object

          })        
          .catch(error => {
            error.text().then(function(text) {
                Vue.prototype.$snotify.error(text);
                return false;
            })
        });
    },
}

